import actions from './actions'

const initialState = {
  all: [],
  list: [],
  meta: [],
  emails: [],
  printData: [],
  printMembersData: [],
  printContactsData: [],
  printParentsData: [],
  members: [],
  contacts: [],
  parents: [],
  membersMeta: [],
  contactsMeta: [],
  parentsMeta: [],
  activatePrint: false,
  activateMemberPrint: false,
  activateContactsPrint: false,
  activateParentsPrint: false,
  loadingAll: false,
  loadingList: false,
  loadingMembers: false,
  loadingContacts: false,
  loadingParents: false,
  loadingDetails: false,
  errors: {},
  move: null,
  moving: false,
  isDeactivatedObject: {},
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state
  }
}
